import { useState, useRef, useEffect } from "react"

const useIntersect = () => {
  const [intersecting, setIntersecting] = useState(false)
  const [node, setNode] = useState(null)

  const observer = useRef(null)

  useEffect(() => {
    if (observer.current) observer.current.disconnect()

    observer.current = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(!entry.isIntersecting)
      },
      {
        root: null,
        rootMargin: "-20px",
        threshold: 0,
      }
    )

    const { current: currentObserver } = observer

    if (node) currentObserver.observe(node)

    return () => observer.current.disconnect()
  }, [node])

  return [setNode, intersecting]
}

export default useIntersect
